import { render, staticRenderFns } from "./InlineButton.vue?vue&type=template&id=3d0364e4&"
import script from "./InlineButton.vue?vue&type=script&lang=js&"
export * from "./InlineButton.vue?vue&type=script&lang=js&"
import style0 from "./InlineButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports